import React, { useEffect, useState } from "react";
import axios from "../../../utils/axios";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import TableContainer from "@mui/material/TableContainer";

const SettlementEftRequestDetails = ({ claimsData,totalAmount  }) => {

  function toTitleCaseKeepAcronyms(str) {
  if (!str) return ""; // ✅ Handle null, undefined, or empty

  const acronyms = ["PLC", "LTD", "AB"];

  return str
    .toLowerCase()
    .split(" ")
    .map((word) => {
      if (acronyms.includes(word.toUpperCase())) {
        return word.toUpperCase(); // keep as is
      }
      return word
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("-");
    })
    .join(" ");
}


  return (
    <>
    <TableContainer
  component={Paper}
  style={{ marginTop: "15px", maxHeight: "400px", overflowY: "auto" }}
>
  <Table
    size="small"
    stickyHeader
    style={{ borderCollapse: "collapse" }}
  >
    <TableHead>
      <TableRow>
        {[
          "S.No",
          "Name",
          "Issuer Name",
          "Bank Name",
          "Branch Name",
          "Account No",
          "Routing No",
          "Total Amount",
        ].map((head, index) => (
          <TableCell
            key={index}
            style={{
              fontSize: "11px",
              border: "1px solid #ccc",
            
              whiteSpace: "nowrap", // prevent wrapping
            }}
          >
            {head}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
   <TableBody>
  {claimsData.map((row, index) => (
    <TableRow
      key={index}
      style={{
        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
        height: "28px",
      }}
    >
      <TableCell style={{ fontSize: "11px", border: "1px solid #ccc", padding: "4px 6px" }}>
        {index + 1}
      </TableCell>
      <TableCell style={{ fontSize: "11px", border: "1px solid #ccc", padding: "4px 6px" }}>
        {row.name}
      </TableCell>
      <TableCell style={{ fontSize: "11px", border: "1px solid #ccc", padding: "4px 6px" }}>
        {row.issuer_name}
      </TableCell>
      <TableCell style={{ fontSize: "11px", border: "1px solid #ccc", padding: "4px 6px" }}>
        {toTitleCaseKeepAcronyms(row.bankName)}
      </TableCell>
      <TableCell style={{ fontSize: "11px", border: "1px solid #ccc", padding: "4px 6px" }}>
        {toTitleCaseKeepAcronyms(row.branchName)}
      </TableCell>
      <TableCell style={{ fontSize: "11px", border: "1px solid #ccc", padding: "4px 6px" }}>
        {row.bAccountNo}
      </TableCell>
      <TableCell style={{ fontSize: "11px", border: "1px solid #ccc", padding: "4px 6px" }}>
        {row.routingNo}
      </TableCell>
      <TableCell style={{ fontSize: "11px", border: "1px solid #ccc", padding: "4px 6px", textAlign: "right" }}>
        {Number(row.totalAmount).toLocaleString()}
      </TableCell>
    </TableRow>
  ))}

  {/* ✅ TOTAL ROW */}
  <TableRow
    style={{
      backgroundColor: "#ffffffff",
      fontWeight: "bold",
    }}
  >
    <TableCell
      colSpan={7}
      style={{
        textAlign: "right",
        fontWeight: "bold",
        fontSize: "11px",
      }}
    >
      Total Amount:
    </TableCell>
    <TableCell
      style={{
        fontWeight: "bold",
        fontSize: "11px",
        border: "1px solid #ccc",
        padding: "4px 6px",
        textAlign: "right",
      }}
    >
      {Number(totalAmount).toLocaleString()} {/* 👈 formatted total */}
    </TableCell>
  </TableRow>
</TableBody>

  </Table>
</TableContainer>

    </>
  );
};

export default SettlementEftRequestDetails;
